import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatafieldTextComponent } from './datafield-text/datafield-text.component';
import { DatafieldNumberComponent } from './datafield-number/datafield-number.component';
import { DatafieldBooleanComponent } from './datafield-boolean/datafield-boolean.component';
import { DatafieldChecklistComponent } from './datafield-checklist/datafield-checklist.component';
import { DatafieldDateComponent } from './datafield-date/datafield-date.component';
import { DatafieldHourComponent } from './datafield-hour/datafield-hour.component';
import { DatafieldImageComponent } from './datafield-image/datafield-image.component';
import { DatafieldRangeComponent } from './datafield-range/datafield-range.component';
import { DatafieldDirective } from './datafield.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { DatasheetSessionComponent } from './datasheet-session/datasheet-session.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DatasheetSessionEditorComponent } from './datasheet-session-editor/datasheet-session-editor.component'
import { PepComponentsModule } from 'src/app/views/modules/pep/components/pep-components.module';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { EditDatasheetSectionModule } from 'src/app/views/modules/pep/components/edit-datasheet-section/edit-datasheet-section.module';
import { DeleteDatasheetSectionModule } from 'src/app/views/modules/pep/components/delete-datasheet-section/delete-datasheet-section.module';
import { AddDatafieldModule } from 'src/app/views/modules/pep/components/add-datafield/add-datafield.module';
import { EditDatafieldModule } from 'src/app/views/modules/pep/components/edit-datafield/edit-datafield.module';
import { ReorderSectionFieldsModule } from 'src/app/views/modules/pep/components/reorder-section-fields/reorder-section-fields.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
	declarations: [
		DatafieldTextComponent,
		DatafieldNumberComponent,
		DatafieldBooleanComponent,
		DatafieldChecklistComponent,
		DatafieldDateComponent,
		DatafieldHourComponent,
		DatafieldImageComponent,
		DatafieldRangeComponent,
		DatafieldDirective,
		DatasheetSessionComponent,
		DatasheetSessionEditorComponent
	],
	imports: [
		CommonModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		NgxImageZoomModule,
		MatSliderModule,
		MatSlideToggleModule,
		FeahterIconModule,
		EditDatasheetSectionModule,
		DeleteDatasheetSectionModule,
		AddDatafieldModule,
		EditDatafieldModule,
		ReorderSectionFieldsModule,
		PepComponentsModule,
		DragDropModule,
	],
	exports: [
		DatafieldTextComponent,
		DatafieldNumberComponent,
		DatafieldBooleanComponent,
		DatafieldChecklistComponent,
		DatafieldDateComponent,
		DatafieldHourComponent,
		DatafieldImageComponent,
		DatafieldRangeComponent,
		DatasheetSessionComponent,
		DatafieldDirective
	]
})
export class DatafieldsComponentsModule { }
